import { WEATHER_TYPES } from './constants/weather';

export default function getIconFromWeather(weather: any) {
  return weather?.currently?.icon
    ? // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      WEATHER_TYPES[weather.currently.icon]
    : 'loader';
}
